module.exports = __webpack_public_path__ + "img/outsale.ad50b171.png";